/**
 * Import Button Component
 * Triggers the import workflow from the Main Page
 */

import React from 'react';
import { FilePlus2 } from 'lucide-react';
import { t } from '../../../i18n';

/**
 * @typedef {Object} ImportButtonProps
 * @property {() => void} onClick - Callback when button is clicked
 */

/**
 * Import Button Component
 * Renders a clickable button that triggers the import dialog
 * @param {ImportButtonProps} props
 * @returns {React.ReactElement}
 */
function ImportButton(props) {
  const { onClick, label, ariaLabel, iconOnly = false } = props;
  const buttonLabel = label || t('dashboard.addNote');
  
  return (
    <button 
      type="button"
      className="btn-import"
      onClick={onClick}
      aria-label={ariaLabel || t('dashboard.addNoteLabel')}
      title={iconOnly ? (ariaLabel || t('dashboard.addNoteLabel')) : undefined}
    >
      {iconOnly ? <FilePlus2 size={22} aria-hidden="true" /> : buttonLabel}
    </button>
  );
}

export default ImportButton;
